
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guest-recruiter",
      function () {
        return require("private-next-pages/guest-recruiter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guest-recruiter"])
      });
    }
  